import MasterICCardSettingPage from './MasterICCardSettingPage';

export default MasterICCardSettingPage;